import bgImagePng from "../../assets/images/bg-pills.png";
import bgImageWebp from "../../assets/images/bg-pills.webp";
import WebpImage from "../UI/WebpImage";
import styles from "./styles.module.scss";

const PeopleBackground = () => {
  return (
    <section className={styles.PeopleBackground}>
      <WebpImage
        srcWebp={bgImageWebp}
        srcFallback={bgImagePng}
        fallbackType="png"
        alt="Bunch of happy people"
        className={styles["PeopleBackground-image"]}
        width={687}
        height={1100}
      />
    </section>
  );
};

export default PeopleBackground;
